import React, { useState } from 'react'
import { useApiListProviderDomainRollup } from '../../../../../api-new/state/auth'
import { useLoad } from '../../../../../shared/hooks/load'
import { RollupTiles } from '../../../../../shared/sso-workspace/fleet-page'
import { formatAgo, formatDateTime } from '../../../../../shared/sso-workspace/format'

// The platform-wide figures (GET /provider-domain/rollup), shown above both
// the connections list and the Domains list so staff see the same snapshot
// wherever they land. Each tile links to where its figure comes from. While
// loading the tiles say so, and a failed load says "Unavailable" rather than
// a reassuring 0 (audit P8).
export const rollupTiles = rollup => {
  const value = key => (rollup === undefined ? '…' : rollup === null ? 'Unavailable' : String(rollup[key] ?? 0))
  const count = key => (rollup ? rollup[key] || 0 : 0)
  const last = rollup && rollup.lastSSOSignInAt

  return [
    { key: 'connections', label: 'Connections', value: value('connections'), detail: rollup ? `${count('connectionsActive')} active` : undefined, to: '/admin/sso/connections' },
    { key: 'domains', label: 'Domains', value: value('domains'), to: '/admin/sso/domains' },
    {
      key: 'overriddenUnproven',
      label: 'Routing without DNS proof',
      value: value('overriddenUnproven'),
      detail: 'overridden, never verified',
      tone: count('overriddenUnproven') > 0 ? 'warn' : null,
      to: '/admin/sso/domains?view=unproven'
    },
    { key: 'atRisk', label: 'At risk', value: value('atRisk'), detail: 'DNS proof lapsed', tone: count('atRisk') > 0 ? 'warn' : null, to: '/admin/sso/domains?state=at_risk' },
    { key: 'orgsWithSSO', label: 'Organizations with SSO', value: value('orgsWithSSO'), detail: 'in their plan' },
    {
      key: 'lastSSOSignInAt',
      label: 'Last SSO sign-in',
      value: rollup === undefined ? '…' : rollup === null ? 'Unavailable' : last ? formatAgo(last) : 'None yet',
      detail: last ? formatDateTime(last) : undefined
    }
  ]
}

export const ProviderRollup = () => {
  const apiListProviderDomainRollup = useApiListProviderDomainRollup()
  const [rollup, setRollup] = useState(undefined)

  useLoad(async () => {
    try {
      const result = await apiListProviderDomainRollup.get()
      setRollup(result || {})
    } catch (err) {
      setRollup(null)
    }
  }, [])

  return <RollupTiles label="single sign-on at a glance" tiles={rollupTiles(rollup)} />
}
